import React, { useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { Logo } from '../Logo';

const MARKETING_LINKS = [
  { label: 'Qué hace Áncora', href: '/#como-gestiona' },
  { label: 'Integraciones', href: '/#integraciones' },
  { label: 'Casos reales', href: '/#casos' },
  { label: 'Planes y precios', href: '/#pricing' },
  { label: 'Quiénes somos', href: '/quienes-somos' },
];

const FAQ_PAGE_LINK = { label: 'Preguntas frecuentes', href: '/preguntas-frecuentes' };
const MOBILE_LINKS = [...MARKETING_LINKS, FAQ_PAGE_LINK];

export const MarketingNavbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="marketing-shell marketing-nav" aria-label="Navegación principal">
      <div className="marketing-nav__inner">
        <a href="/" className="marketing-nav__brand" aria-label="Áncora Automations — Inicio">
          <Logo variant="light" />
        </a>

        <div className="marketing-nav__links" aria-label="Secciones de la web">
          {MARKETING_LINKS.map((link) => (
            <a key={link.href} href={link.href}>{link.label}</a>
          ))}
        </div>

        <a className="marketing-nav__cta" href="/#contacto">
          Cuéntanos tu caso
          <ArrowUpRight aria-hidden="true" size={17} />
        </a>

        <button
          type="button"
          className="marketing-nav__toggle"
          aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={isOpen}
          aria-controls="marketing-mobile-menu"
          onClick={() => setIsOpen((current) => !current)}
        >
          {isOpen ? <X aria-hidden="true" size={24} /> : <Menu aria-hidden="true" size={24} />}
        </button>
      </div>

      {isOpen && (
        <div id="marketing-mobile-menu" className="marketing-nav__mobile">
          {MOBILE_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setIsOpen(false)}>{link.label}</a>
          ))}
          <a className="marketing-nav__mobile-cta" href="/#contacto" onClick={() => setIsOpen(false)}>
            Cuéntanos tu caso
            <ArrowUpRight aria-hidden="true" size={17} />
          </a>
        </div>
      )}
    </nav>
  );
};
